export default "__VITE_ASSET__84e66637__"